
















import Vue from 'vue';
import commonVuex from '../vuex/common';

export default Vue.extend({
  mixins: [commonVuex],
  methods: {
    accept(): void {
      window.localStorage.setItem('acceptDisclaimer', 'true');
      this.$emit('updated');
    },
  },
});
